import React, { useEffect, useState } from 'react';
import { Modal, Table, Checkbox, Tag, message } from 'antd';
import { apiRequest } from '../../../service/apiRequest';  // your API util
import { showSuccess, showError } from '../../../components/errorHandler';


interface ModuleItem {
  module_id: number;
  module_name: string;
  mom_id:string | null;
  module_status:number;
}

interface Props {
  visible: boolean;
  onCancel: () => void;
  moduleData: ModuleItem[];
  organizationId: string; // pass org id to link modules
  onSaved: () => void; // callback after successful save
}

const ModuleOrgMapping: React.FC<Props> = ({
  visible,
  onCancel,
  moduleData,
  organizationId,
  onSaved,
}) => {
  const [selectedModuleIds, setselectedModuleIds] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const mappedIds = moduleData
      .filter((mdl) => mdl.mom_id !== null)
      .map((mdl) => mdl.module_id);
    setselectedModuleIds(mappedIds);
  }, [moduleData]);

  const onCheckChange = (moduleId: number, checked: boolean) => {
    setselectedModuleIds((prev) =>
      checked ? [...prev, moduleId] : prev.filter((id) => id !== moduleId)
    );
  };

  const columns = [
    {
      title: 'Module Name',
      dataIndex: 'module_name',
      key: 'module_name',
    },
    {
      title: 'Status',
      dataIndex: 'module_status',
      key: 'module_status',
      render: (status: number) =>
        status === 1 ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        ),
    },
    {
      title: 'Mapped',
      dataIndex: 'mom_id',
      key: 'mapped',
      render: (mom_id: string | null) =>
        mom_id ? (
          <Tag color="blue">Mapped</Tag>
        ) : (
          <Tag color="default">Not Mapped</Tag>
        ),
    },
    {
      title: 'Select',
      key: 'select',
      render: (_: any, record: ModuleItem) => (
        <Checkbox
          checked={selectedModuleIds.includes(record.module_id)}
          onChange={(e) => onCheckChange(record.module_id, e.target.checked)}
        />
      ),
    },
  ];

  const handleSave = async () => {
    setLoading(true);
    try {
      // API call - replace URL & payload as needed
      await apiRequest({
        method: 'put',
        url: `/map-module-to-organization/${organizationId}`, // example endpoint
        data: { module_ids: selectedModuleIds },
      });
      showSuccess('modules mapped successfully');
      onSaved(); // notify parent to refresh or close modal
      onCancel();
    } catch (error) {
      console.error(error);
      showError('Failed to save module mappings');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Map modules to Organization"
      visible={visible}
      onCancel={onCancel}
      onOk={handleSave}
      okText="Save"
      confirmLoading={loading}
      width={600}
    >
      <Table
        rowKey="module_id"
        dataSource={moduleData}
        columns={columns}
        pagination={false}
        scroll={{ y: 300 }}
      />
    </Modal>
  );
};

export default ModuleOrgMapping;
